<template>
    <div class="bigBox">
        <div class="enterprise" v-if="statusInformation.user_type==1 && statusInformation.auth_status==1">
            <p>创建企业</p>
            <div @click="authentication">
                创建企业
            </div>
        </div>
        <!--        <div class="enterprise" v-if="statusInformation.user_type==1 && statusInformation.auth_status==0">-->
        <!--            <p>个人认证</p>-->
        <!--            <div @click="certificationBtn">-->
        <!--                去认证-->
        <!--            </div>-->
        <!--        </div>-->
        <el-dialog
                title="前往认证"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                :modal-append-to-body="false"
                width="30%"
        >
            <el-form>
                <el-form-item label="企业名称">
                    <el-input v-model="companyName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="企业地址">
                    <el-input v-model="address" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="decertification">确 定</el-button>
          </span>
        </el-dialog>
        <!--      加入企业-->
        <el-dialog
                title="加入企业"
                :visible.sync="joinEnterprise"
                :close-on-click-modal="false"
                :modal-append-to-body="false"
                width="30%"
        >
            <el-form>
                <el-form-item label="企业名称">
                    <el-input v-model="companyName" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="joinEnterprise = false">取 消</el-button>
              <el-button type="primary" @click="joinBtn">确 定</el-button>
          </span>
        </el-dialog>
        <!--      首页-->
        <div class="indexBox">
            <el-row>
                <el-col :span="16">
                    <div class="topBox">
                        <div class="initiate" style="width: 25%">
                            <div class="startBox" @click="directInitiation">
                                <p>直接发起</p>
                                <span>通过文件发起合同</span>
                            </div>
                        </div>
                        <div class="initiate" style="width: 25%">
                            <div class="startBox" @click="selectTemplate">
                                <p>模板发起</p>
                                <span>通过模板发起合同</span>
                            </div>
                        </div>
                        <div class="initiate" style="width: 25%">
                            <div class="startBox" @click="dialogVisible_lian = true">
                                <p>发起立案</p>
                                <span>填写信息单个立案</span>
                            </div>
                        </div>
                        <div class="initiate" style="width: 25%">
                            <div class="startBox" @click="dialogVisible_daoru = true" style="margin-right: 5px">
                                <p>导入案件</p>
                                <span>批量导入案件</span>
                            </div>
                        </div>

                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="dateBox">
                        <div class="dayBox">
                            <div class="day">
                                <p>{{date}}</p>
                            </div>
                        </div>
                        <div class="calendarBox">
                            <div class="calendar">
                                <p style="margin-bottom: 10px">{{year}}年{{month}}月{{date}}日 {{week}}</p>
                                <p>农历 {{getLunarDay.lunarYear}} {{getLunarDay.dateStr}}</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!--          合同份数-->
            <el-row style="margin-top: 10px;display: flex" :span="24">
<!--                <el-col :span="5" style="padding: 0px 5px">-->
<!--                    <div class="copiesBox">-->
<!--                        <div class="surplusBox">-->
<!--                            <div class="surplus">剩余合同份数</div>-->
<!--                            <div class="surplusCopies">{{copies.contract_num}}<span-->
<!--                                    style="font-size: 16px;margin-top: 10px">份</span></div>-->
<!--                        </div>-->
<!--                        &lt;!&ndash;                        <div class="usedBox">&ndash;&gt;-->
<!--                        &lt;!&ndash;                            <p>已用合同份数</p>&ndash;&gt;-->
<!--                        &lt;!&ndash;                            <p style="font-size: 30px;color: #409eff">{{copies.used_contract_num}}<span&ndash;&gt;-->
<!--                        &lt;!&ndash;                                    style="font-size: 14px">份</span></p>&ndash;&gt;-->
<!--                        &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </div>-->
<!--                </el-col>-->
                <el-col :span="5" style="padding: 0px 5px">
                    <div class="copiesBox">
                        <div class="surplusBox">
                            <div class="surplus">发起失败份数</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="failBtn">{{copies.faqi_fail_num}}<span
                                    style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" style="padding: 0px 5px">
                    <div class="copiesBox">
                        <div class="surplusBox">
                            <div class="surplus">待我签署份数</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="treatMe">
                                {{copies.daiwo_num}}<span style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" style="padding: 0px 5px">
                    <div class="copiesBox">
                        <div class="surplusBox">
                            <div class="surplus">待他人签署份数</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="treatOthers">
                                {{copies.daitaren_num}}<span style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" style="padding: 0px 5px">
                    <div class="copiesBox">
                        <div class="surplusBox">
                            <div class="surplus">即将截止合同份数</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="cutoffBtn">{{copies.jijiang_num}}<span
                                    style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5" style="padding: 0px 5px">
                    <div class="copiesBox">
                        <div class="surplusBox">
                            <div class="surplus">可用余额</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="balanceBtn">{{copies.keyong_money}}<span
                                style="font-size: 16px;margin-top: 10px">元</span></div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div style="width: 100%;display: flex">
                <div class="leftBox">
                    <div class="copiesBox leftBoxcontent">
                        <div class="surplusBox">
                            <div class="surplus">我申请仲裁的案件数量</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="applyForCase">{{copies.my_zhcai_num}}<span
                                    style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                    <div class="copiesBox leftBoxcontent">
                        <div class="surplusBox">
                            <div class="surplus">我被申请仲裁的案件数量</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="BeAppliedForCase">
                                {{copies.bei_zhcai_num}}<span style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                    <div class="copiesBox leftBoxcontent">
                        <div class="surplusBox">
                            <div class="surplus">我申请调解的案件数量</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="applyFortjCase">
                                {{copies.my_tiaojie_num}}<span style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                    <div class="copiesBox leftBoxcontent">
                        <div class="surplusBox">
                            <div class="surplus">我被申请调解的案件数量</div>
                            <div class="surplusCopies" style="cursor: pointer" @click="BeAppliedFortjCase">
                                {{copies.bei_tiaojie_num}}<span style="font-size: 16px;margin-top: 10px">份</span></div>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="dynamicBox">
                        <div class="dynamic">
                            <div class="dynamicInformation">动态</div>
                            <div v-if="copies.msg_list!=''">
                                <div class="dynamicList" v-for="(item,index) in copies.msg_list" :key="index">
                                    <p @click="messageBtn(item)"><span>{{item.msg_type}}</span> {{item.content}}</p>
                                </div>
                            </div>
                            <div v-else>
                                <el-empty description="暂无数据"></el-empty>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        发起立案-->
        <el-dialog
            title="发起立案"
            :visible.sync="dialogVisible_lian"
            width="30%">
            <el-form ref="form" :model="initiateForm">
                <el-form-item label="立案类型">
                    <el-radio-group v-model="initiateForm.type">
                        <el-radio label="1">仲裁立案</el-radio>
                        <el-radio label="2">调解立案</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toInitiate">确 定</el-button>
            </span>
        </el-dialog>
<!--        批量导入案件-->
        <el-dialog
            title="批量导入案件"
            :visible.sync="dialogVisible_daoru"
            width="30%">
            <el-form ref="form" :model="importForm">
                <el-form-item label="导入类型">
                    <el-radio-group v-model="importForm.type">
                        <el-radio label="1">仲裁批量导入</el-radio>
                        <el-radio label="2">调解批量导入</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="skipCase">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import operation from './components/operation';
    import othersOperation from './components/othersOperation';
    import enterprise from './components/enterprise';
    import histogram from './components/histogram';
    import {
        certification,
        enterpriseExpire,
        enterpriseName,
        individualExpire, joinCompany, membership,
        personalDetails, warnIndividual
    } from '../../api/personal';
    import { contractCopy } from '../../api/contract';
    import { getLunar } from 'chinese-lunar-calendar';

    export default {
        name: 'index',
        inject: ['reload'],
        components: {
            operation,
            othersOperation,
            enterprise,
            histogram
        },
        data() {
            return {
                initiateForm:{
                    type:'1'
                },
                importForm:{
                    type:'1'
                },
                dialogVisible_lian:false,
                dialogVisible_daoru:false,
                dialogVisible: false,
                joinEnterprise: false,  //加入企业
                statusInformation: '',
                companyName: '',
                address: '',
                copies: '',  //合同份数
                getLunarDay: '',
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                date: new Date().getDate(),
                week: '', //星期
                data: [],
                option: {
                    border: false,
                    align: 'center',
                    menuAlign: 'center',
                    editBtn: false,
                    delBtn: false,
                    stripe: true,
                    viewBtn: true,
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn: false, //左上角新增
                    column: [
                        {
                            label: '合同标题',
                            prop: 'title'
                        }, {
                            label: '发件人',
                            prop: 'sender'
                        }, {
                            label: '签署人',
                            prop: 'signed'
                        }, {
                            label: '合同状态',
                            prop: 'state'
                        }, {
                            label: '发起时间',
                            prop: 'time'
                        }
                    ]
                }
            };
        },
        methods: {
            //企业认证
            authentication() {
                this.dialogVisible = true;
            },
            //认证
            decertification() {
                enterpriseName(this.companyName, this.address).then(res => {
                    if (res.code == 200) {
                        this.dialogVisible = false;
                        this.companyName = '';
                        window.location.href = res.data.auth_url;
                    } else if (res.code == 602) {
                        this.dialogVisible = false;
                        // this.joinEnterprise = true;
                        this.$message.error(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }

                });
            },
            //加入企业
            joinBtn() {
                joinCompany(this.companyName).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.joinEnterprise = false;
                        this.reload();
                    } else {
                        this.$message.error(res.msg);
                        this.joinEnterprise = false;
                    }
                });
            },
            selectTemplate() {
                this.$router.push('/formwork');
            },
            //发起立案
            toInitiate() {
                if (this.initiateForm.type == '1') {
                    this.$router.push('/initiate');
                }else if (this.initiateForm.type == '2') {
                    this.$router.push('/mediationFiling');
                }
            },
            //导入案件
            skipCase() {
                if (this.importForm.type == '1') {
                    this.$router.push('/batchImport');
                }else if (this.importForm.type == '2'){
                    this.$router.push('/batchImportCase');
                }
            },
            // 直接发起
            directInitiation(){
                if (this.statusInformation.mode==1){
                    this.$router.push('/directInitiation')
                }else {
                    this.$router.push('/directInitiation_pay')
                }
            },
            //存证管理
            depository() {
                this.$router.push('/contract');
            },
            //个人认证
            // certificationBtn() {
            //     certification().then(res => {
            //         if (res.code == 200) {
            //             sessionStorage.removeItem('shenfen');
            //             window.location.href = res.data.auth_url;
            //             return;
            //         } else {
            //             this.$message.error(res.msg);
            //             return;
            //         }
            //     });
            // },
            messageBtn(item) {
                this.$router.push({ path: '/messagePage', query: { id: item.id } });
            },
            //待我签署份数
            treatMe() {
                this.$router.push({ path: '/contract', query: { type: 'fourth' } });
            },
            //发起失败份数
            failBtn() {
                this.$router.push({ path: '/contract', query: { type: 'tenth' } });
            },
            //待他人签署
            treatOthers() {
                this.$router.push({ path: '/contract', query: { type: 'fifth' } });
            },
            //即将截止
            cutoffBtn() {
                this.$router.push({ path: '/contract', query: { type: 'fourth' } });
            },
            //已完成
            completeBtn() {
                this.$router.push({ path: '/contract', query: { type: 'sixth' } });
            },
            caseBtn() {
                this.$router.push({ path: '/lawCase' });
            },
            //我申请的仲裁案件数量
            applyForCase(){
                this.$router.push({ path: '/lawCase', query: { type: 'first' } });
            },
            //我被申请的仲裁案件数量
            BeAppliedForCase(){
                this.$router.push({ path: '/lawCase', query: { type: 'second' } });
            },
            //我申请的调解案件数量
            applyFortjCase(){
                this.$router.push({ path: '/mediate', query: { type: 'first' } });
            },
            //我被申请的调解案件数量
            BeAppliedFortjCase(){
                this.$router.push({ path: '/mediate', query: { type: 'second' } });
            },
            balanceBtn(){
                console.log(this.statusInformation.user_type);
                if (this.statusInformation.user_type == 2){
                    this.$router.push({ path: '/billRecord' });
                }else if(this.statusInformation.user_type == 1){
                    this.$router.push({ path: '/billRecord_gr' })
                }else{
                    this.$message.error('暂无权限查看');
                }
            }

        },
        created() {
            this.getLunarDay = getLunar(this.year, this.month, this.date);
            let days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            let today = new Date();
            let weekday = today.getDay();
            this.week = days[weekday];
            //个人信息
            membership().then(res => {
                if (!sessionStorage.getItem('shenfen')) {
                    if (res.data.last_identity) {
                        sessionStorage.setItem('shenfen', JSON.stringify(res.data.last_identity));
                        this.statusInformation = res.data.last_identity;
                    } else {
                        sessionStorage.setItem('shenfen', JSON.stringify(res.data.identity[0]));
                        this.statusInformation = res.data.identity[0];
                    }
                } else if (sessionStorage.getItem('shenfen')) {
                    var identity = JSON.parse(sessionStorage.getItem('shenfen'));
                    this.statusInformation = identity;
                }
                //个人认证
                if (this.statusInformation.psn_auth_status == 0) {
                    certification().then(res => {
                        if (res.code == 200) {
                            this.$message.error('请完成实名认证！');
                            setTimeout(() => {
                                sessionStorage.removeItem('shenfen');
                                window.location.href = res.data.auth_url;
                                return;
                            }, 2000);
                            return;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
                //个人认证过期
                if (this.statusInformation.user_type == 1 && this.statusInformation.auth_status == 1 && this.statusInformation.is_expire == 1) {
                    //E签宝个人认证授权过期
                    individualExpire().then(res => {
                        if (res.code == 200) {
                            window.location.href = res.data.auth_url;
                            return;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
                //企业管理员 企业过期
                if (this.statusInformation.user_type == 2 && this.statusInformation.is_expire == 1) {
                    //E签宝企业认证授权过期
                    enterpriseExpire().then(res => {
                        if (res.code == 200) {
                            window.location.href = res.data.auth_url;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
                //企业员工 企业过期
                if (this.statusInformation.user_type == 3 && this.statusInformation.is_expire == 1) {
                    enterpriseExpire().then(res => {
                        if (res.code == 200) {
                            window.location.href = res.data.auth_url;
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
                //个人认证成功后新增一个弹窗
                if (this.statusInformation.user_type == 1 && this.statusInformation.psn_auth_status == 1) {
                    warnIndividual().then(res => {
                        if (res.code == 200) {
                            if (res.data.is_remind == 0) {
                                this.$confirm('如您需要通过公司身份发起电子合同并签章，查看公司案件等，请创建企业 ', '提示', {
                                    confirmButtonText: '下一步：创建企业',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    this.dialogVisible = true;
                                }).catch(() => {

                                });
                            }
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }
                // console.log(identity);

            });
            //身份信息状态

            //合同份数
            setTimeout(() => {
                contractCopy().then(res => {
                    this.copies = res.data;
                });
            }, 500);

        }

    };
</script>

<style scoped>
    .topBox {
        display: flex;
        justify-content: flex-end
    }

    .initiate {
        width: 25%;
        /*margin: 0px 5px;*/
        padding-left: 5px;
    }

    .startBox,
    .importBox {
        height: 90px;
        border-radius: 20px;
        background-image: linear-gradient(to right, #2245b4, #3f62f4);
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        color: #fff;
        cursor: pointer;
    }

    .startBox > p,
    .importBox > p {
        font-size: 26px;
        font-weight: 600;
    }

    .startBox > span,
    .importBox > span {
        font-size: 14px;
    }

    .examine > P {
        font-weight: 700;
    }

    .examine > span {
        cursor: pointer;
        color: #2a4ac0;
    }

    /deep/ .avue-crud__menu {
        min-height: 0px;
    }

    .certification,
    .enterprise {
        height: 50px;
        width: 100%;
        border-radius: 5px;
        background-color: #fff;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .certification > p,
    .enterprise > p {
        margin-left: 20px;
    }

    .certification > div,
    .enterprise > div {
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        margin-right: 20px;
        background-color: #2751c7;
        color: #fff;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
    }

    /deep/ .el-form-item {
        display: flex;
    }

    /deep/ .el-form-item__content {
        width: 80%;
    }

    .indexBox {
        /*padding: 10px;*/
        /*background-color: #fff;*/
        border-radius: 5px;
    }

    .copiesBox {
        margin-bottom: 10px;
        height: 220px;
        display: flex;
        background-color: #fff;
        border-radius: 5px;
    }

    .surplusBox {
        width: 100%;
        height: 100%;
        border-radius: 5px;
    }

    .surplusBox:hover {
        -webkit-box-shadow: #ccc 0px 5px 5px 0px;
        -moz-box-shadow: #ccc 0px 5px 5px 0px;
        box-shadow: #ccc 0px 5px 5px 0px;

    }

    .usedBox {
        width: 50%;
        height: 100%;
        border: 1px solid #dfdfdf;
        border-radius: 5px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        justify-content: space-between;
        padding: 0px 20px;
    }

    .dateBox {
        margin-left: 5px;
        display: flex;
        /*border: 1px solid #eeeeee;*/
        height: 90px;
        border-radius: 10px;
        background-color: #fff;
    }

    .dayBox {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .day {
        width: 76px;
        height: 76px;
        background-image: url(../../assets/img/date-box-img.png);
    }

    .day > p {
        text-align: center;
        line-height: 76px;
        color: #fff;
        font-size: 40px;
    }

    .calendarBox {
        width: 70%;
        display: flex;
        align-items: center;
        text-align: center;
    }

    .calendar {
        width: 100%;
        color: #333333;
    }

    .surplus {
        height: 20%;
        line-height: 40px;
        padding: 0px 20px;
        border-bottom: 1px solid #e6e8ea;
        font-size: 14px;
        color: #333333;
    }

    .surplusCopies {
        font-size: 40px;
        color: #409eff;
        text-align: center;
        /*line-height: 162px;*/
        height: 80%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .surplusCopies:hover {
        background-color: #f2f2f2;
        border-radius: 5px;
    }

    .dynamicBox {
        height: 450px;
        /*border: 1px solid #eeeeee;*/
        border-radius: 5px;
        background-color: #fff;
        margin: 0px 5px 0px 5px;
    }

    .dynamicBox:hover,
    .dateBox:hover,
    .startBox:hover {
        -webkit-box-shadow: #ccc 0px 5px 5px;
        -moz-box-shadow: #ccc 0px 5px 5px;
        box-shadow: #ccc 0px 5px 5px;
        /*box-shadow: 5px 5px 5px #ccc;*/
    }

    .dynamicInformation {
        height: 45px;
        line-height: 45px;
        padding: 0px 20px;
        border-bottom: 1px solid #e6e8ea;
        font-size: 14px;
        color: #333333;
    }

    .dynamicList > p {
        color: #333333;
        font-size: 12px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 12px;
        cursor: pointer;
    }

    .dynamicList > p:hover {
        color: #2d8cf0;
    }

    /deep/ .el-empty__image {
        width: 150px;
        height: 150px;
    }
    .leftBox{
        width: 70%;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: space-around;
    }
    .rightBox{
        width: 30%;
    }
    .leftBoxcontent{
        width: 49%;
    }
</style>
